<div class="container-fluid p-0">
  <div class="row no-gutters">
    <div class="col-lg-2">
      <app-navbar></app-navbar>
    </div>
    <div class="col-lg-10 contenido">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="mb-0">Familias (V2)</h4>
        <span *ngIf="loading" class="badge badge-info">Cargando...</span>
      </div>
      <hr />

      <div class="card mb-3">
        <div class="card-body">
          <h6 class="card-title">Agregar familia</h6>
          <div class="form-row align-items-end">
            <div class="col-md-3">
              <label class="font-weight-bold">Nombre</label>
              <input class="form-control" [(ngModel)]="formulario.nombre" placeholder="Light, Elite, Superior..." />
            </div>
            <div class="col-md-4">
              <label class="font-weight-bold">Descripcion</label>
              <input class="form-control" [(ngModel)]="formulario.descripcion" placeholder="Texto corto para alumnos" />
            </div>
            <div class="col-md-2">
              <label class="font-weight-bold">Imagen</label>
              <input type="file" class="form-control-file" (change)="onFileChangeNuevo($event)" />
            </div>
            <div class="col-md-1">
              <label class="font-weight-bold">Activo</label>
              <select class="form-control" [(ngModel)]="formulario.activo">
                <option [value]="1">Si</option>
                <option [value]="0">No</option>
              </select>
            </div>
            <div class="col-md-2 mt-3 mt-md-0">
              <button class="btn btn-success btn-block" (click)="agregarFamilia()">Guardar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <h6 class="card-title mb-0">Listado</h6>
            <div class="input-group search-box">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                  </svg>
                </span>
              </div>
              <input class="form-control" [(ngModel)]="filtro" placeholder="Buscar familia..." />
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Imagen</th>
                  <th>Nombre</th>
                  <th>Descripcion</th>
                  <th>Activo</th>
                  <th class="text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let familia of familiasFiltradas">
                  <td>{{ familia.id }}</td>
                  <td>
                    <img *ngIf="familia.imagen" [src]="familia.imagen" alt="imagen familia" class="thumb">
                    <span *ngIf="!familia.imagen">-</span>
                  </td>
                  <td>{{ familia.nombre }}</td>
                  <td>{{ familia.descripcion || '-' }}</td>
                  <td>{{ familia.activo === 0 ? 'No' : 'Si' }}</td>
                  <td class="text-right">
                    <button class="btn btn-sm btn-outline-secondary mr-2" (click)="abrirGrupos(gruposFamiliaModal, familia)">Grupos</button>
                    <button class="btn btn-sm btn-outline-primary mr-2" (click)="abrirEditar(editFamiliaModal, familia)">Editar</button>
                    <button class="btn btn-sm btn-outline-danger" (click)="eliminarFamilia(familia.id)">Eliminar</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editFamiliaModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-editar-familia">Editar familia</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="font-weight-bold">Nombre</label>
      <input class="form-control" [(ngModel)]="formularioEdit.nombre" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Descripcion</label>
      <textarea class="form-control" rows="3" [(ngModel)]="formularioEdit.descripcion"></textarea>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Imagen</label>
      <input type="file" class="form-control-file" (change)="onFileChangeEditar($event)" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Activo</label>
      <select class="form-control" [(ngModel)]="formularioEdit.activo">
        <option [value]="1">Si</option>
        <option [value]="0">No</option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="actualizarFamilia()">Guardar</button>
  </div>
</ng-template>

<ng-template #gruposFamiliaModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-grupos-familia">Grupos para {{ familiaSeleccionada?.nombre }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="grupo-list">
      <label class="grupo-item" *ngFor="let grupo of grupos">
        <input type="checkbox" [checked]="grupoSeleccionado(grupo.id)" (change)="seleccionarGrupo(grupo.id, $event)">
        <span>{{ grupo.nombre }}</span>
        <small *ngIf="grupo.carrera"> - {{ grupo.carrera }}</small>
      </label>
    </div>
    <p class="text-muted small mt-3 mb-0">Si no seleccionas grupos, la familia queda sin restriccion especifica.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="guardarGrupos()">Guardar grupos</button>
  </div>
</ng-template>
